import { NgModule } from '@angular/core';

import { CoreModule }              from '../core/core.module';
import { ImportComponent }         from './import.component';
import { ImportEquationComponent } from './import.equation.component';
import { ImportProgressComponent } from './import.progress.component';
import { ImportsService }          from './imports.service';
import { SharedModule }            from '../shared/shared.module';

@NgModule({
  declarations: [
    ImportComponent,
    ImportEquationComponent,
    ImportProgressComponent
  ],
  entryComponents: [
    ImportProgressComponent
  ],
  exports: [
    ImportComponent,
    ImportEquationComponent
  ],
  imports: [
    CoreModule,
    SharedModule
  ],
  providers: [
    ImportsService
  ]
})
export class ImportsModule {}
